import CheckIcon from "@mui/icons-material/Check"
import CloseIcon from "@mui/icons-material/Close"
import { TableCell, TableRow } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useState } from "react"
import { useDispatch } from "react-redux"

import { green, red } from "@mui/material/colors"
import { AppDispatch } from "../../../store"
import { CorporatesState } from "../../../store/actions/corporates"
import { openDrawer } from "../../../store/bank/bank-edit-slice"

const CorporateRow = ({ row }: { row: CorporatesState }) => {
	const dispatch = useDispatch<AppDispatch>()
	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
	const [openRow, setOpenRow] = useState<boolean>(false)

	const TableCellStyled = styled(TableCell)(() => ({
		paddingLeft: "8px",
	}))

	const handleEditCorporate = (corporate: CorporatesState) => {
		dispatch(openDrawer({ isEditMode: true, corporate: corporate }))
	}

	return (
		<TableRow
			hover
			tabIndex={-1}
			key={row.id}
			style={{
				backgroundColor: row.enabled
					? openRow
						? "#F5F7FD"
						: "#FFF"
					: "rgba(211, 211, 211, 0.1)",
			}}
		>
			<TableCellStyled component="td" scope="row" padding="none">
				{row.corporateSenderName}
			</TableCellStyled>
			<TableCellStyled align="right">
				{row?.contiCorrenti?.length}
			</TableCellStyled>
			<TableCellStyled align="left">
				{row.enabled ? (
					<CheckIcon sx={{ color: green[500] }} />
				) : (
					<CloseIcon sx={{ color: red[500] }} />
				)}
			</TableCellStyled>
		</TableRow>
	)
}

export default CorporateRow
